import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthenticationStateManager';
import Icon from '../AppIcon';

const NavigationTabBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated, authLoading } = useAuth();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('');

  const getPersonalizedGreeting = () => {
    if (!isAuthenticated || !user) {
      return { label: 'SignIn', path: '/authentication-portal', icon: 'LogIn' };
    }

    const role = user.role?.toUpperCase();

    if (role === 'ADMIN') {
      return { label: 'Hi Admin', path: '/admin', icon: 'Shield' };
    }

    if (role === 'STUDENT' || role === 'USER') {
      return { label: 'Hi Student', path: '/candidate/dashboard', icon: 'GraduationCap' };
    }

    return { label: 'Hi User', path: '/', icon: 'User' };
  };

  const navigationItems = [
    { label: 'Pricing', path: '/pricing-plans', icon: 'DollarSign' },
    { label: 'Blog', path: '/blog-content-hub', icon: 'BookOpen' },
    { label: 'About', path: '/about-platform', icon: 'Info' },
    { label: 'Jobs', path: '/job-hunter', icon: 'Briefcase' },
    { label: 'Questions Bank', path: '/company-questions', icon: 'Building' },
    {
      label: 'Resume',
      path: isAuthenticated ? '/candidate/resume' : '/resume-builder',
      icon: 'FileText'
    },
    // 🔥 SEO PAGE (IMPORTANT)
    { label: 'AI Interview', path: '/ai-mock-interview-india', icon: 'Sparkles' },
    getPersonalizedGreeting()
  ];

  useEffect(() => {
    const currentPath = location.pathname;
    const activeItem = navigationItems.find(item =>
      currentPath.startsWith(item.path)
    );
    setActiveTab(activeItem?.label || '');
  }, [location.pathname]);

  const handleNavigation = (e, path, label) => {
    e.preventDefault();
    if (authLoading) return;

    setActiveTab(label);
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-40 bg-card shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 md:h-16">

          {/* LOGO (SEO FIXED) */}
          <a href="/" className="flex items-center">
            <img
              src="/assets/images/Logo_Botervue.png"
              alt="Botervue AI Mock Interview India"
              className="w-[140px] md:w-[180px] h-auto object-contain"
            />
          </a>

          {/* Desktop */}
          <div className="hidden md:flex items-center space-x-1">
            {navigationItems.map((item) => (
              <a
                key={item.label}
                href={item.path}
                onClick={(e) => handleNavigation(e, item.path, item.label)}
                className={`px-4 py-2 rounded-md transition-base
                  ${activeTab === item.label
                    ? 'bg-primary text-primary-foreground'
                    : 'text-foreground hover:bg-muted'
                  }`}
              >
                <div className="flex items-center space-x-2">
                  <Icon name={item.icon} size={20} />
                  <span className="font-medium">{item.label}</span>
                </div>
              </a>
            ))}
          </div>

          {/* Mobile Toggle */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-md"
          >
            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
          </button>
        </div>
      </div>

      {/* Mobile */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-card border-t border-border">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navigationItems.map((item) => (
              <a
                key={item.label}
                href={item.path}
                onClick={(e) => handleNavigation(e, item.path, item.label)}
                className="w-full flex items-center space-x-3 px-3 py-3 rounded-md hover:bg-muted"
              >
                <Icon name={item.icon} size={20} />
                <span className="font-medium">{item.label}</span>
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavigationTabBar;